import { useState, useEffect, useRef } from 'react';
import { Button, Input } from 'src/core/components';
import { hoc } from 'src/core/utils';
import { useOnScreen } from '../../../../hooks';
import { useTryZynProps } from '../../try-zyn.props';
import { Popup } from '../popup';
import styles from './form.module.scss';

import { page } from 'src/locale';
/**
 * <Form />
 */

const Form = hoc(
  useTryZynProps,
  ({
    locale,
    popup,
    phone,
    loading,
    errorPhone,
    isTouched,
    onChange,
    setIsTouched,
    validateForm,
    handleClose,
    popupType,
    time,
    setSubscription,
    errorOtp,
    code,
    onKeyDown,
    onCheckOtp,
    errors,
    handleClick,
    onCallMe,
    callMe,
    calling,
    subscription,
    pushDLonVisible
  }) => {
    const itemUsage = useRef(null);
    useOnScreen(itemUsage) && pushDLonVisible('try_zyn_scroll_form');

    return (
      <div id='form' ref={itemUsage}>
        <div className={styles.form}>
          <div className={styles.wrapper}>
            <h2 className={styles.title}>{page.form.title[locale]}</h2>
            <p className={styles.text}>{page.form.text[locale]}</p>
            <Input
              label={page.form.label[locale]}
              type='tel'
              name='phone'
              mask='+3\8 999 999 99 99'
              maskChar=' '
              value={phone}
              disabled={loading}
              onInputChange={onChange}
              error={errorPhone}
              isError={isTouched && !!errorPhone}
              onFocus={() => setIsTouched(true)}
              className={styles.input}
              placeholder=''
            />
            <Button
              onClick={() => validateForm(phone)}
              className={styles.btn}
              color='primary'
            >
              {page.form.button[locale]}
            </Button>
          </div>
        </div>
        {popup && (
          <Popup
            props={{
              handleClose,
              popupType,
              loading,
              time,
              setSubscription,
              errorOtp,
              code,
              onKeyDown,
              onCheckOtp,
              errors,
              handleClick,
              onCallMe,
              callMe,
              calling,
              subscription,
              locale
            }}
          />
        )}
      </div>
    );
  }
);

export { Form };
